import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_ENDPOINTS } from "../../../../util/constants";
import { actionTypes } from "../../../Auth/_redux/authRedux";
import { actions } from "../../../Dashboard/_redux/dashboardRedux";
import { setToastInfoForAccountStatus } from "../../../Auth/_redux/userProfileSlice";
import { showSnackBar } from "../../../../SnackbarUtils";

const initialListingsState = {
  phonebookList: [],
  phoneBookMeta: {},
  currentPage: 1,
  pageSize: 10,
};

export const fetchPhonebookLists = createAsyncThunk(
  "phonebookSlice/fetchPhonebookLists",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.getPhonebookDetails, {
        params: params,
      });
      dispatch(
        actions.setLoadingState({
          resource: "phonebook_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      dispatch(
        actions.setLoadingState({
          resource: "phonebook_lists",
          loading_state: "loaded",
        })
      );
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchNdndcCountDetails = createAsyncThunk(
  "phonebookSlice/fetchNdndcCountDetails",
  async (params, { dispatch, rejectWithValue }) => {
    const { phonebook_id, phonebookListsPayload } = params;
    try {
      const response = await axios.get(API_ENDPOINTS.getNdndcCountDetails, {
        params: { phonebook_id: phonebook_id },
      }).then((res) => {
        if(res.data.ndnc_count === -2){
          showSnackBar("Some Error Encountered! Please check the CSV.",{ variant: 'error' })
        }
      });
      dispatch(fetchPhonebookLists(phonebookListsPayload));
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const deletePhonebookList = createAsyncThunk(
  "phonebookSlice/deletePhonebookList",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.deletePhonebook, {
        params: params,
      });
      dispatch(
        actions.setLoadingState({
          resource: "phonebook_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.response });
    }
  }
);

export const downloadReportStatus = createAsyncThunk(
  "phonebookSlice/downloadReportStatus",
  async (params, { dispatch, rejectWithValue }) => {
    let url = API_ENDPOINTS.downloadNumberStatus;
    const { id } = params;
    if (params.type === "DND") {
      url = API_ENDPOINTS.downloadDNDStatus;
    }
    try {
      const response = await axios
        .get(url, {
          params: { id },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let filename = "numberstatus";
          if (params.type === "DND") {
            filename = "dndstatus";
          }
          link.target = "_blank";
          link.setAttribute("download", `${filename}.csv`);
          document.body.appendChild(link);
          link.click();
        });
      dispatch(
        actions.setLoadingState({
          resource: "phonebook_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const phonebookSlice = createSlice({
  name: "phonebookSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });
    builder.addCase(fetchPhonebookLists.pending, (state) => {
      state.phonebookList = [];
    });
    builder.addCase(fetchPhonebookLists.fulfilled, (state, { payload }) => {
      const { data } = payload;
      const { meta, objects } = data;
      state.phonebookList = objects;
      state.phoneBookMeta = meta;
    });
    builder.addCase(fetchPhonebookLists.rejected, (state, action) => {});
  },

  reducers: {
    onPageAndPageSizeChange: (state, action) => {
      const { payload } = action;
      state.currentPage = payload["currentPage"];
      state.pageSize = payload["pageSize"];
    },
  },
});

export const { onPageAndPageSizeChange } = phonebookSlice.actions;
export default phonebookSlice.reducer;
